import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";
import variables from "../variables";

const {addClass, removeClass, hasClass, get, getAll} = $dom

const groupMenuSelector = '.js-menu-group'
const groupSubmenuSelector = '.js-submenu-group'
const itemsMenuSelector = '.js-menu-items'

const activeMenu = 'activeMenu'

export default function () {
    const handleEnterMenu = e => {
        if (hasClass(e.target, itemsMenuSelector.slice(1))) {
            clearAllMenuActive()
            addClass(e.target, activeMenu)
            const menu = e.target.closest(groupMenuSelector + ' div[data-menu]')
            const submenu = get(`${groupSubmenuSelector} div[data-submenu=${menu.dataset.menu}]`)

            hiddenAllSubmenu(submenu)

            addClass(submenu, variables.classNames.visible)
        }
    }

    const clearAllMenuActive = () => {
        const menu = getAll(`${groupMenuSelector} div[data-menu]`)

        menu.forEach(item => {
            const button = get('.button', item)
            removeClass(button, activeMenu)
        })
    }

    const hiddenAllSubmenu = () => {
        const submenu = getAll(`${groupSubmenuSelector} div[data-submenu]`)

        submenu.forEach(item => removeClass(item, variables.classNames.visible))
    }

    return new Component({
        name: 'menu',
        requiredTargets: [groupMenuSelector, groupSubmenuSelector, itemsMenuSelector],
        onInit() {
            $events
                .add('mouseenter', itemsMenuSelector, handleEnterMenu)
        },
        onDestroy() {
            $events
                .remove('mouseenter', itemsMenuSelector, handleEnterMenu)
        },
    })

}
